module.exports = __webpack_public_path__ + "img/img2.8cca3074.jpg";